<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
            <div class="mobile_head_operate" >
                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="warehouse_add_container mobile_container">
            <div class="warehouse_add_wrap">
                <div class="product_list">
                    <ul>
                        <li v-for="(item,index) in formData.productData" :key="index">
                            <i class="iconfont icon-guanbi_dise" @click="handleClickDel(item,index)"></i>
                            <div class="product_field product_border">
                                <van-field @click="handleClickSelectStock(item)" clickable is-link label="" :value="item.stock_name"  name="stock_id" placeholder="请选择出库仓库"  readonly></van-field>
                            </div>
                            <div class="product_field product_border flex_js_wrap">
                                <van-popover :get-container="getContainer" v-model="item.productPopoverShow"  style="left: 0 !important;" :show-arrow="false" :offset="[0,0]" trigger="click" placement="bottom-start">
                                    <div class="productItemBox" v-if="productList.length>0">
                                        <div class="product_item flex_js_wrap" :class="{ 'disabled-item':  list.disabled }" v-for="list in productList" @click="handleClickSelectProduct(item,list)">
                                            <div class="product_name ellipsis">{{ list.name }}</div>
                                            <div class="product_tag" v-if="list.disabled">无库存</div>
                                        </div>
                                    </div>
                                    <template #reference>
                                        <van-field v-model="item.name" @input="handleInputProduct(item)"  @focus="handleInputProduct(item)" @blur="handleInputBlurProduct(item)" label="" placeholder="请输入产品名称" ></van-field>
                                    </template>
                                </van-popover>
                                <span>
                                    <span class="field_button" @click="handleClickSelectProductOut(item)">选择</span>
                                </span>

                            </div>

                            <div class="product_field product_border">
                                <van-field  type="number" label="库存数量" readonly placeholder="系统带出">
                                    <template #input>
                                        <span v-if="item.stock_info && item.stock_info.total_num">{{item.stock_info.total_num}} {{item.unit}}</span>
                                    </template>
                                </van-field>
                            </div>
                            <div class="product_field ">
                                <div class="bt required">入库数量/产品编码</div>
                                <div class="select_number flex_js_wrap">
                                    <van-field v-model="item.no_code_num" @input="handleInputNoCodeNum(item)"  label="" placeholder="请输入数量"></van-field>
                                    <div class="select_code_box flex_js_wrap">
                                       <span>
                                            <span class="line"></span>
                                            <span class="select_btn" @click="handleClickSelectCode(item)">选择编码</span>
                                       </span>
                                        <span class="total_num">共{{item.total_num}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <div class="product_add">
                        <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增组</span>
                    </div>
                </div>

                <div class="field_item">
                    <div class="field_name">附件</div>
                    <div class="field_content">
                        <div class="file_list" v-if="formData.file_list && formData.file_list.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in formData.file_list" :key="file_idx">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                        <span @click="formData.file_list.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                        <div class="file_upload">
                            <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            <i class="iconfont icon-upload"></i>上传附件
                        </div>

                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="formData.note"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </div>



        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

        <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :stockList="productInfo ? productInfo.stock_list : []" :selectedStockId="(productInfo && productInfo.stock_id) ? productInfo.stock_id : 0" @success="selectStockSuccess"/>
        <CodeIdentification :codeIdentificationPopupShow.sync="codeIdentificationPopupShow" v-if="codeIdentificationPopupShow" :sourceType="'out'" :productInfo="productInfo" :selectedCodeData="selectedCodeData" @success="identificationCodeSuccess" />
        <SelectCode  :selectCodePopupShow.sync="selectCodePopupShow" v-if="selectCodePopupShow"  :selectedCodeData="selectedCodeData" :productInfo="productInfo" @success="selectCodeOneSuccess" />
        <SelectProductOut :selectProductOutPopupShow.sync="selectProductOutPopupShow" :selectStockId="productInfo.stock_id" v-if="selectProductOutPopupShow" @success="selectProductSuccess"/>
    </div>
</template>

<script>
import { searchOutProducts,addStockOut,chooseCode,getStocksByProduct,codeOutGetProduct,getStocksAuth} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize,removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import SelectStock from "../component/select_stock"
import CodeIdentification from "../component/code_identification"
import SelectCode from "../component/select_code"
import SelectProductOut from "../component/select_product_out"
import {Dialog, ImagePreview} from "vant";
import {mapState} from "vuex";
import {EventBus} from '@/utils/eventBus';
export default {
    name: "OutWarehouseAdd",
    components: {ReturnNavBar,SelectStock,CodeIdentification,SelectCode,SelectProductOut},
    data() {
        return {
            btnDisabled:false,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"codeIdentification", text: "粘贴编码识别", icon: "iconfont icon-chuku" },
                {value:"scan", text: "扫码出库", icon: "iconfont icon-saoyisao" },
                {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
            ],
            formData:{
                productData:[
                    {
                        name:'',
                        stock_id:'',
                        stock_name:'',
                        sku_id:'',
                        sku_key:'',
                        unit:'台',
                        code_num:0, //在库编码数量
                        code_list:[], //选择的编码
                        no_code_num:0, //在库无编码数量
                        total_num:0, //选择的总数量
                        stock_info:{
                            code_num:0, //在库编码数量
                            no_code_num:0, //在库无编码数量
                            total_num:0, //在库的总数量
                        },
                        stock_list:[]
                    }
                ],
                file_list:[],
                note:''
            },
            selectStockPopupShow:false,
            productInfo:null,
            codeIdentificationPopupShow:false,
            selectedCodeData:[],//已选编码
            productList:[],

            selectCodePopupShow:false,
            selectProductOutPopupShow:false,
            project_manage_id:''
        };
    },
    computed: {
        ...mapState(['inventoryProductData']),
    },
    created() {
        if(this.$route.query.project_manage_id){
            this.project_manage_id = this.$route.query.project_manage_id
        }
    },
    activated() {
        // 组件被激活
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.setInventoryProductData(this.inventoryProductData)
        }
    },
    methods: {
        setInventoryProductData(data){
            if(data && data.length){
                this.formData.productData = []
                data.forEach((item)=>{
                    let json = {
                        name:item.name,
                        stock_id:item.stock_id,
                        stock_name:item.stock_id ? item.stocks?.name : '',
                        sku_id:item.sku_id,
                        sku_key:item.sku_key,
                        unit:item.unit,
                        code_num:0, //选择的编码数量
                        code_list:[], //选择的编码
                        no_code_num:0, //选择的无编码数量
                        total_num:0, //选择的总数量
                        stock_info:{
                            code_num:item.stock_id ? item.code_num :0, //在库编码数量
                            no_code_num:item.stock_id ? item.no_code_num : 0, //在库无编码数量
                            total_num:item.stock_id ? item.total_num : 0, //在库的总数量
                        },
                        stock_list:item.stock_id ? [
                            {
                                id:item.stock_id,
                                name:item.stocks.name,
                                code_num:item.code_num ? item.code_num :0, //在库编码数量
                                no_code_num:item.no_code_num ? item.no_code_num : 0, //在库无编码数量
                                total_num:item.total_num ? item.total_num : 0, //在库的总数量
                            }
                        ] : []
                    }
                    this.formData.productData.push(json)
                })
                this.$store.dispatch("inventoryProductData", []);
            }
        },
        getContainer() {
            return  document.querySelector('.warehouse_add_container')
        },
        // 头部+号操作
        handleClickHeadOperate(item){
            this.headOperatePopoverShow = false
            if(item.value == 'codeIdentification'){
                this.productInfo = null
                this.selectedCodeData = []
                this.formData.productData.forEach(item =>{
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                })
                this.codeIdentificationPopupShow = true
            }else if(item.value == 'batch_stock'){
                this.productInfo = null
                this.selectStockPopupShow = true
            }
        },
        // 编码识别后回调
        identificationCodeSuccess(data){
            this.loading = true
            let code_list = []
            if(this.formData.productData.length == 1){
                if(!this.formData.productData[0].stock_id && !this.formData.productData[0].name && !this.formData.productData[0].total_num) {
                    this.formData.productData.splice(0,1)
                }
            }
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = data.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != data.code_list.length){
                this.$toast('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){ this.loading = false;  return  false }

            codeOutGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item)
                    })
                }
                this.loading = false
            })
        },
        // 合并产品
        mergeProductFunction(row){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.stock_id == row.stock_id){
                        let code_list = row.code_list.map((map)=>{return {code:map}})
                        this.$set(item,'code_list',item.code_list.concat(code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        flag = false
                    }
                })
            }
            if(flag){
                let stock_info = row.stocks.find(find => find.id == row.stock_id)
                let json = {
                    name:row.name,
                    stock_id:row.stock_id,
                    stock_name:row.stocks.find(find => find.id == row.stock_id)?.name,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                    unit:row.unit,
                    code_num:row.code_num, //选择的编码数量
                    code_list:row.code_list.map((map)=>{return {code:map}}), //选择的编码
                    no_code_num:row.no_code_num, //选择的编码数量
                    total_num:row.total_num, //选择的总数量
                    stock_info:{
                        code_num:stock_info.code_num, //在库编码数量
                        no_code_num:stock_info.no_code_num, //在库无编码数量
                        total_num:stock_info.total_num, //在库的总数量
                    },
                    stock_list:row.stocks
                }
                this.formData.productData.push(json)
            }

        },
        // 输入时
        handleInputProduct(item){
            this.getSearchProducts(item)
        },
        getSearchProducts(item){
            let postData  = {
                keyword:item.name,
                stock_id:(item && item.stock_id) ? item.stock_id :''
            }
            searchOutProducts(postData).then(res => {
                if (res.code === 200) {
                    let data = res.data ? res.data.map((item)=>{
                        item.disabled = item.zero_stock == true ? true : false
                        return item
                    }) : []
                    this.productList = data
                }
            })
        },
        // 失去焦点
        handleInputBlurProduct(item){
           this.clearProductInfo(item)
        },
        // 没有相应的产品清除相关信息
        clearProductInfo(item){
            if(item.name){
                let info = this.productList.find(find => find.name == item.name)
                if(!info){
                    this.$set(item,'name','')
                    this.$set(item,'sku_id','')
                    this.$set(item,'sku_key','')
                    this.$set(item,'unit','')
                    this.$set(item,'stock_list',[])
                    this.$set(item,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
                    this.$set(item,'code_num',0)
                    this.$set(item,'code_list',[])
                    this.$set(item,'no_code_num',0)
                    this.$set(item,'total_num',0)
                }else{
                    this.handleClickSelectProduct(item,info)
                }
            }
        },
        // 选中产品
        handleClickSelectProduct(item,list){
            if(list.disabled){
                this.$set(item,'name','')
                this.$toast('该产品无库存')
                return false
            }
            this.$set(item,'name',list.name)
            if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                this.$toast(`${list.name}已存在`)
                this.$set(item,'name','')
                return false
            }
            this.$set(item,'sku_id',list.sku_id)
            this.$set(item,'sku_key',list.sku_key)
            this.$set(item,'unit',list.unit)
            this.$set(item,'stock_list',list.stocks)
            this.handleClickClearStock(item)
            if(item.stock_id){
                // 有仓库id 的情况下 获取产品信息时带出的仓库才会是有权限的仓库
                this.$set(item,'stock_list',item.stock_id ? list.stocks : [])
                let stock_info = item.stock_list.find(find => find.id == item.stock_id)
                if(stock_info){
                    this.$set(item,'stock_info',stock_info)
                }else{
                    this.$set(item,'stock_id','')
                    this.$set(item,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
                }
            }
            this.$set(item,'productPopoverShow',false)
        },
        // 清除信息
        handleClickClearStock(row){
            this.$set(row,'code_num',0)
            this.$set(row,'code_list',[])
            this.$set(row,'no_code_num',0)
            this.$set(row,'total_num',0)
            this.$set(row,'stock_info',{code_num:0,no_code_num:0,total_num:0})
        },
        // 选择产品编码
        handleClickSelectCode(item){
            if(item.stock_id == '')return this.$toast('请先选择仓库')
            if(item.name == '')return this.$toast('请先选择产品')
            if(item.stock_info && item.stock_info.code_num == 0){
                return this.$toast('该产品在该库中无编码产品')
            }
            this.productInfo = item
            this.selectedCodeData = JSON.parse(JSON.stringify(item.code_list))
            this.selectCodePopupShow = true
        },
        // 选择单个产品编码后回调
        selectCodeOneSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
        },

        // 输入无编码数量
        handleInputNoCodeNum(item){
            const num = item.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num) || !item.stock_id) {
                this.$set(item,'no_code_num',0)
            } else {
                // // 如果输入的数量大于总数量则等于总数量
                if(item.no_code_num > item.stock_info.total_num){
                    this.$set(item,'no_code_num',item.stock_info.total_num)
                }
                // // 如果输入的数量大于无编码总数量则等于无编码总数量  并把多余的数量变为有编码的
                if(item.no_code_num > item.stock_info.no_code_num){
                    let remaining =  item.no_code_num  - item.stock_info.no_code_num // 多余的数量
                    this.$set(item,'no_code_num',item.stock_info.no_code_num)
                    this.automatic_replenishment(item,remaining) //自动补充编码
                }else{
                    this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                }
            }
        } ,
        // 自动补充编码
        automatic_replenishment(item,remaining){
            let postData = {
                page: 1,
                pageSize: remaining + item.code_list.length, // 需要自动选择的编码+已经选择了的编码
                product_name:item.name,
                sku_id:item.sku_id,
                sku_key:item.sku_key,
                stock_id:item.stock_id,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(item.code_list.map(item => item.code));
                    // 过滤 list，获取不在 code_list 中的值  并且状态是正常的编码
                    const filteredList = list.filter(item => !existingCodes.has(item.code) && item.status == 0);
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    item.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(item,'code_num',item.code_list.length)
                    this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                    Dialog.alert({
                        title: '库存数量已自动补充',
                        message: '此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！',
                    });
                }else{
                    this.btnDisabled = false
                }
            })
        },

        // 选择出库产品
        handleClickSelectProductOut(item){
            this.productInfo = item
            this.selectProductOutPopupShow = true
        },

        // 选择产品回调
        selectProductSuccess(data){
            this.$set(this.productInfo,'name',data.name)
            if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                this.$toast(`${data.name}已存在`)
                this.$set(this.productInfo,'name','')
                return false
            }
            this.handleClickClearStock(this.productInfo)
            this.$set(this.productInfo,'sku_id',data.sku_id)
            this.$set(this.productInfo,'sku_key',data.sku_key)
            this.$set(this.productInfo,'stock_id',data.stock_id)
            this.$set(this.productInfo,'unit',data.unit)
            this.$set(this.productInfo,'stock_list',[data.stocks])
            this.$set(this.productInfo,'stock_info',{ code_num:data.code_num,no_code_num:data.no_code_num,total_num:data.total_num,})
        },
        // 选择仓库
        handleClickSelectStock(item){
            if(item.name){
                let postData  = {
                    product_name:item.name,
                    sku_id:item.sku_id,
                    sku_key:item.sku_key,
                }
                getStocksByProduct(postData).then(res => {
                    if (res.code === 200) {
                        let data = res.data ? res.data.map((item)=>{
                            return {
                                id:item.stock_id,
                                name:item.stocks.name,
                                code_num:item.code_num,
                                no_code_num:item.no_code_num,
                                total_num:item.total_num,
                            }
                        }) : []
                        this.$set(item,'stock_list',data)
                        this.productInfo = item
                        this.selectStockPopupShow = true
                    }
                })
            }else{
                this.productInfo = item
                this.selectStockPopupShow = true
            }

        },
        // 选择仓库后回调
        selectStockSuccess(data){
            if(this.productInfo){
                this.handleClickClearStock(this.productInfo)
                this.$set(this.productInfo,'stock_id',data.id)
                this.$set(this.productInfo,'stock_name',data.name)
                if(this.productInfo.name){
                    let stock_info = this.productInfo.stock_list.find(find => find.id == data.id)
                    if(stock_info){
                        this.$set(this.productInfo,'stock_info',stock_info)
                    }
                }

                this.$nextTick(()=>{
                    if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                        this.$toast(`${this.productInfo.name}已存在`)
                        this.$set(this.productInfo,'stock_id','')
                        this.$set(this.productInfo,'stock_name','')
                        this.$set(this.productInfo,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
                        return false
                    }
                })
            }else{
                let postData = {
                    stock_id:data.id,
                    product_list:this.formData.productData
                            .filter(find => find.name)
                            .map(map => {
                                return {
                                    product_name: map.name,
                                    sku_id: map.sku_id,
                                    sku_key: map.sku_key
                                };
                            })
                }
                getStocksAuth(postData).then(res => {
                    if (res.code === 200) {
                        let dataInfo = res.data
                        this.formData.productData.forEach(list => {
                            let productItem = dataInfo.find(find => find.product_name == list.name && find.sku_id == list.sku_id && find.sku_key == list.sku_key && find.total_num > 0)
                            let stock_auth = productItem?.stock_auth

                            if(stock_auth){
                                this.handleClickClearStock(list)
                                let stock_info = {
                                    id:data.id,
                                    name:data.name,
                                    no_code_num:productItem.no_code_num,
                                    code_num:productItem.code_num,
                                    total_num:productItem.total_num,
                                }
                                this.$set(list,'stock_info',stock_info)
                                this.$set(list,'stock_id',stock_info.id)
                                this.$set(list,'stock_name',stock_info.name)
                                this.$set(list,'stock_list',[
                                    {
                                        id:data.id,
                                        name:data.name,
                                        no_code_num:productItem.no_code_num,
                                        code_num:productItem.code_num,
                                        total_num:productItem.total_num,
                                    }
                                ])
                            }else{
                                this.handleClickClearStock(list)
                                if(!list.name){
                                    this.$set(list,'stock_id',data.id)
                                    this.$set(list,'stock_name',data.name)
                                }
                            }
                            if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                                this.$message.error(`${productItem.product_name}已存在`)
                                this.$set(list,'stock_id','')
                                this.$set(list,'stock_name','')
                                this.handleClickClearStock(list)

                            }
                        })
                    }
                })
            }
            this.productInfo = null
        },
        // 校验是否有仓库 +  产品名称 重复的
        VerifyDuplicate(){
            let data =  JSON.parse(JSON.stringify(this.formData.productData))
            const seen = new Map();
            const duplicates = [];
            data.forEach((item, index) => {
                const key = `${item.name}_${item.stock_id}`;
                if (seen.has(key) && item.name && item.stock_id) {
                    duplicates.push({ current: item, previousIndex: seen.get(key) });
                } else {
                    seen.set(key, index);
                }
            });
            return duplicates;
        },
        // 删除
        handleClickDel(item,index){
            if(this.formData.productData.length == 1) return this.$toast('当前数据行不可删除，最少保留一行')
            this.formData.productData.splice(index,1)
        },
        // 新增行
        handleClickAdd(){
            let json = {
                name:'',
                stock_id:'',
                stock_name:'',
                sku_id:'',
                sku_key:'',
                unit:'台',
                code_num:0, //选择的编码数量
                code_list:[], //选择的编码
                no_code_num:0, //选择的无编码数量
                total_num:0, //选择的总数量
                stock_info:{
                    code_num:0, //在库编码数量
                    no_code_num:0, //在库无编码数量
                    total_num:0, //在库的总数量
                },
                stock_list:[]
            }
            this.formData.productData.push(json)
        },

        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },

        handleClickReturnRouter(){
            if (this.formData.note || this.formData.file_list.length > 0 || (this.formData.productData.length > 0 && this.formData.productData.filter(item => (item.name || item.stock_id || item.total_num )).length>0 )){
                Dialog.confirm({
                    title: "取消",
                    message: "取消后，编辑内容不保留，是否取消！",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                })
                .then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                })
                .catch(() => { });
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm() {
            let flag = false
            let productData = JSON.parse(JSON.stringify(this.formData.productData))
            console.log(productData);
            if(productData.length == 0){return this.$message.error(`至少出库一个产品`) }
            productData.forEach((item,index) => {
                if(!item.name && !flag){
                    this.$toast(`请选择第${index+1}个产品`)
                    flag = true
                }
                if(!item.stock_id && !flag){
                    this.$toast(`请选择${item.name}仓库`)
                    flag = true
                }
                if(!item.total_num && !flag){
                    this.$toast(`请输入${item.name}出库数量`)
                    flag = true
                }
                if(item.code_list && item.code_list.length>0){
                    this.$set(item, 'code_list', item.code_list.map(codeItem => codeItem.code));
                }
                delete item.productPopoverShow
                delete item.stock_info
                delete item.stock_name
                delete item.stock_list
            })
            if(flag){return  false}
            let postData = {
                stock_type:'general', //出入库类型（普通）
                product_list:productData,
                files:this.formData.file_list,
                note:this.formData.note,
            }
            if(this.project_manage_id){
                postData.related_type = 'project_manage' //业务类型 （项目）
                postData.related_id = this.project_manage_id
            }
            Dialog.confirm({
                title: "提交出库",
                message: "确定执行出库操作吗？ \r\n 提交后无法撤回，请谨慎操作。",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                this.btnDisabled = true
                addStockOut(postData).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: "出库成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                EventBus.$emit('warehouseUpdated');
                                removeTag(this.$route)
                                this.$router.go(-1);
                                this.btnDisabled = false
                            },
                        });
                    }else{
                        this.btnDisabled = false
                    }
                })

            })
            .catch(() => { });


        },




    },
};
</script>

<style lang="scss" scoped>
.warehouse_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .warehouse_add_wrap{
        background: #fff;
        .product_list{
            width: 100%;
            padding: 12px 16px;
            box-sizing: border-box;
            ul{
                li{
                    width: 100%;
                    margin-bottom: 10px;
                    border-radius: 6px;
                    background: rgba(247, 248, 250, 1);
                    position: relative;
                    .icon-guanbi_dise{
                        position: absolute;
                        right: -6px;
                        top: -6px;
                        font-size: 16px;
                        color: rgba(191, 191, 191, 1);
                    }
                    .product_field{
                        width: 100%;
                        padding: 0 12px;
                        .van-popover__wrapper{
                            flex: 1;
                            display: block;
                        }
                        &.product_border{
                            position: relative;
                            &:before{
                                position: absolute;
                                width: calc(100% - 24px);
                                height: 1px;
                                background: rgba(232, 232, 232, 1);
                                content: " ";
                                left: 12px;
                                bottom: 0;
                                z-index: 9;
                            }
                        }
                        .van-cell{
                            padding-left: 0;
                            padding-right: 0;
                            background: rgba(247, 248, 250, 1);
                        }
                        .field_button{
                            font-size: 14px;
                            padding-left: 8px;
                            color: rgba(41, 144, 255, 1);
                            line-height: 14px;
                            border-left: 1px solid rgba(232, 232, 232, 1);
                        }

                        .bt{
                            padding-top: 10px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            &.required{
                                position: relative;
                                padding-left: 6px;
                                &:before{
                                    position: absolute;
                                    left: 0;
                                    top: 10px;
                                    content: "*";
                                    color: rgba(228, 65, 68, 1);
                                }
                            }
                        }
                        .select_number{
                            width: 100%;
                            .van-cell{
                                width: 78px;
                            }
                            .select_code_box{
                                flex: 1;
                                line-height: 24px;
                                position: relative;
                                .select_btn{
                                    font-size: 14px;
                                    color: rgba(41, 144, 255, 1);
                                }
                                .total_num{
                                    border-radius: 4px;
                                    background: rgba(255, 255, 255, 1);
                                    min-width: 22px;
                                    padding: 0 4px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }

                    }
                }
            }
            .product_add{
                text-align: center;
                line-height: 22px;
                span{
                    color: rgba(25, 144, 255, 1);
                    i{
                        font-size: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .field_item{
            width: 100%;
            border-top: 1px solid rgba(247, 248, 250, 1);
            padding: 10px 16px;
            box-sizing: border-box;

            .field_name{
                width: 100%;
                line-height: 22px;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 4px;
            }
            .field_content{
                width: 100%;
                .van-cell{
                    padding:0 0 4px 0;
                }
                ::v-deep .van-cell--required::before{
                    position: initial;
                    margin-right: 2px;
                }
                .file_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            margin-bottom: 10px;
                            border-radius: 2px;
                            background: rgba(249, 249, 249, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            line-height: 20px;
                            padding: 0 8px;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                width: calc(100% - 50px);
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);
                            }
                            div{
                                width: 48px;
                                span{
                                    width: 16px;
                                    margin-left: 8px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                                i{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                }
                            }
                        }
                    }
                }
                .file_note{
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 18px;
                    margin-bottom: 34px;
                }
                .file_upload{
                    width: 100px;
                    position: relative;
                    line-height: 22px;
                    margin: 0 auto;
                    color: rgba(25, 144, 255, 1);
                    font-size: 14px;
                    text-align: center;
                    i{
                        margin-right: 8px;
                    }
                    input{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                }

            }
        }
    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}
::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
    display: none !important;
}
.productItemBox{
    width: calc(100vw - 56px);
    padding: 8px 2px;
    box-sizing: border-box;
    max-height: 220px;
    overflow-y: auto;
    .product_item{
        width: 100%;
        line-height: 30px;
        padding: 0 12px;
        color: rgba(102, 102, 102, 1);
        &.disabled-item{
            .product_name{
                color: rgb(191, 191, 191);
            }
            &:active{
                background: transparent;
                color: rgba(102, 102, 102, 1);
            }
        }
        &:active{
            color: rgba(102, 102, 102, 1);
            background: rgba(0, 0, 0, 0.04);
        }
        .product_name {
            display: block;
            width: calc(100% - 50px);
        }
        .product_tag {
            width: 40px;
            height: 22px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(240, 170, 50, 0.1);
            line-height: 22px;
            font-size: 12px;
            color: rgba(240, 170, 50, 1);
            text-align: center;
        }
    }

}
</style>
